import { Outlet, createFileRoute } from "@tanstack/react-router";
import { AxiosError } from "axios";

import NotFoundPage from "@/components/NotFoundPage";
import usePlan from "@/hooks/usePlan";
import usePlanId from "@/hooks/usePlanId";

export const Route = createFileRoute("/_app/_dashboard/$planId")({
  component: PlanScope,
});

/**
 * Layout over every `/$planId/*` page. A plan id the backend rejects (a
 * random or foreign numeric id → 404) previously left the page stuck on its
 * loading state while its children kept polling the API with the bad id —
 * resolve it to the 404 page instead. Non-numeric segments collapse to
 * `"default"` in `usePlanId` and fall back to the subscription's own plan,
 * so they never error here. 403s are deliberately not handled: the plan
 * endpoint 403s for account-level states (2FA pending, suspension) that
 * `RouteGuard` already routes.
 */
function PlanScope() {
  const planId = usePlanId();
  const { error } = usePlan(planId);

  if ((error as AxiosError | undefined)?.response?.status === 404) {
    return <NotFoundPage />;
  }

  return <Outlet />;
}
